import { render, staticRenderFns } from "./CourseScreen.vue?vue&type=template&id=1386d2b8&"
import script from "./CourseScreen.vue?vue&type=script&lang=js&"
export * from "./CourseScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports